import * as time from "./time"
import * as domain from "../domain/index"

export async function ping(win: Window): Promise<Window> {
    // eslint-disable-next-line
    const pong = new Promise<Window>(async (resolve, reject) => {
        const request = new domain.PingRequestMessage()
        let ponged = false

        const responseListener = (event: MessageEvent<domain.PingResponseMessage>) => {
            const response = event.data
            if (response.id !== request.id) {
                return
            }

            window.removeEventListener("message", responseListener)
            if (response.error) {
                reject(response.error)
            } else {
                ponged = true
                resolve(win)
            }
        }
        window.addEventListener("message", responseListener)

        while (!ponged) {
            win.postMessage(request, "*")
            await time.sleep(50)
        }
    })

    return pong
}
